function getCartInventoryFromLiquid() {
  var el = document.getElementById('farmex-cart-inventory-data');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent || '{}');
  } catch (e) {
    return {};
  }
}

async function getVariantInventoryQuantity(variantId) {
  if (!variantId) return null;

  var liquidMap = getCartInventoryFromLiquid();
  if (Object.prototype.hasOwnProperty.call(liquidMap, String(variantId))) {
    var fromLiquid = liquidMap[String(variantId)];
    if (fromLiquid === null || typeof fromLiquid === 'undefined') return null;
    var q = Number(fromLiquid);
    return isNaN(q) ? null : (q >= 0 ? q : 0);
  }

  try {
    var response = await fetch('/variants/' + variantId + '.js', { method: 'GET' });
    if (!response.ok) return null;
    var variant = await response.json();
    if (typeof variant.inventory_quantity === 'number') {
      return variant.inventory_quantity >= 0 ? variant.inventory_quantity : 0;
    }
    return null;
  } catch (e) {
    console.warn('No se pudo consultar inventario para variantId', variantId, e);
    return null;
  }
}

/**
 * Ajuste unico antes de getNegotiatedPrice: min(cantidad, maxima_compra convenio, stock Shopify).
 */
async function capMetlifeProductsBeforeQuote(products, originalsIds) {
  var skuMax = {};
  (originalsIds || []).forEach(function (row) {
    var sku = String(row.sku || '').trim();
    var max = parseInt(row.maxima_compra, 10);
    if (sku && !isNaN(max) && max > 0) {
      skuMax[sku] = max;
    }
  });

  var adjusted = [];
  var capped = [];
  var byVariant = {};

  for (var i = 0; i < (products || []).length; i++) {
    var p = Object.assign({}, products[i]);
    var sku = String(p.sku || '').trim();
    var fromQty = Number(p.cantidad) || 0;
    var targetQty = fromQty;

    var maxCompra = skuMax[sku];
    if (typeof maxCompra === 'number' && targetQty > maxCompra) {
      targetQty = maxCompra;
    }

    var variantId = p.variantid || p.variantId || p.variant_id;
    if (variantId) {
      if (byVariant[variantId] === undefined) {
        byVariant[variantId] = await getVariantInventoryQuantity(variantId);
      }
      var available = byVariant[variantId];
      if (typeof available === 'number' && targetQty > available) {
        targetQty = available;
      }
    }

    if (targetQty !== fromQty) {
      adjusted.push({
        sku: sku,
        nombre: p.nombreProducto,
        from: fromQty,
        to: targetQty
      });
      p.cantidad = targetQty;
    }

    if (targetQty > 0) {
      capped.push(p);
    }
  }

  return { products: capped, adjusted: adjusted };
}

async function applySkuQuantityAdjustmentsToCart(adjustedRows) {
  if (!Array.isArray(adjustedRows) || adjustedRows.length === 0) return;
  if (typeof getCart !== 'function') return;

  var bySku = {};
  adjustedRows.forEach(function (row) {
    var sku = String(row.sku || '').trim();
    var toQty = Number(row.to);
    if (!sku || isNaN(toQty)) return;
    bySku[sku] = toQty;
  });

  var cart = await getCart();
  var requests = [];

  Object.keys(bySku).forEach(function (sku) {
    var target = bySku[sku];
    var lines = (cart.items || [])
      .map(function (item, idx) {
        return { line: idx + 1, sku: String(item.sku || '').trim(), qty: Number(item.quantity) || 0 };
      })
      .filter(function (row) { return row.sku === sku; });

    if (!lines.length) return;
    var remaining = target;
    lines.forEach(function (row) {
      var newQty = remaining > 0 ? Math.min(row.qty, remaining) : 0;
      remaining = Math.max(0, remaining - newQty);
      if (newQty !== row.qty) {
        requests.push({ line: row.line, quantity: newQty });
      }
    });
  });

  if (requests.length) {
    requests.sort(function (a, b) { return b.line - a.line; });
    for (var i = 0; i < requests.length; i++) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: requests[i].line, quantity: requests[i].quantity })
      });
    }
  }
}

async function showMetlifeQuantityAdjustmentsSwal(adjustedRows) {
  if (!adjustedRows.length || typeof Swal === 'undefined') return;
  await Swal.fire({
    icon: 'warning',
    title: 'Cantidad reajustada automaticamente',
    html: 'Se ajustaron cantidades segun limite de convenio y/o stock disponible:<br>' +
      adjustedRows.map(function (a) {
        return (a.nombre || a.sku) + ': ' + a.from + ' -> ' + a.to;
      }).join('<br>'),
    confirmButtonText: 'Entendido'
  });
}

/**
 * Prepara productos + carrito y cotiza Metlife en una sola llamada (sin reintentos 1 a 1).
 */
async function prepareMetlifeQuoteAndCall(products, originalsIds, rut, campaniaBeneficio, selectedCouponId, selectedEmailId) {
  if (typeof builderProductsCertifiedMetlife !== 'function' || typeof getProductsCertifiedMetlifeAPI !== 'function') {
    throw new Error('Dependencias no disponibles para cotizar Metlife.');
  }

  var prepared = await capMetlifeProductsBeforeQuote(products, originalsIds);
  if (prepared.adjusted.length > 0) {
    await applySkuQuantityAdjustmentsToCart(prepared.adjusted);
    await showMetlifeQuantityAdjustmentsSwal(prepared.adjusted);
  }

  if (!prepared.products.length) {
    if (typeof Swal !== 'undefined') {
      await Swal.fire({
        icon: 'warning',
        title: 'Sin stock disponible',
        text: 'No hay unidades disponibles para continuar con la cotizacion del convenio.'
      });
    }
    throw new Error('Sin productos disponibles para cotizar despues del ajuste de stock.');
  }

  var requestBody = builderProductsCertifiedMetlife(
    prepared.products,
    rut,
    campaniaBeneficio,
    selectedCouponId,
    selectedEmailId
  );
  var response = await getProductsCertifiedMetlifeAPI(requestBody);

  return {
    response: response,
    requestBody: requestBody,
    products: prepared.products,
    adjusted: prepared.adjusted
  };
}

window.FarmexCartConvenios = {
  getCartInventoryFromLiquid: getCartInventoryFromLiquid,
  getVariantInventoryQuantity: getVariantInventoryQuantity,
  capMetlifeProductsBeforeQuote: capMetlifeProductsBeforeQuote,
  applySkuQuantityAdjustmentsToCart: applySkuQuantityAdjustmentsToCart,
  showMetlifeQuantityAdjustmentsSwal: showMetlifeQuantityAdjustmentsSwal,
  prepareMetlifeQuoteAndCall: prepareMetlifeQuoteAndCall
};

window.capMetlifeProductsBeforeQuote = capMetlifeProductsBeforeQuote;
window.prepareMetlifeQuoteAndCall = prepareMetlifeQuoteAndCall;
window.applySkuQuantityAdjustmentsToCart = applySkuQuantityAdjustmentsToCart;
